import React from "react";
import { Loader, Table } from "@culturehq/components";

const ProfileTable = ({ loading, children }) => (
  <Loader loading={loading}>
    <div className="col-sm-12 table-container">
      <Table>{children}</Table>
    </div>
  </Loader>
);

export default ProfileTable;
